/* tslint:disable */
/* eslint-disable */
/**
 * Protech PCS API
 * API for Protech PCS ingestion process
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { RepairOrderRequestLine } from './RepairOrderRequestLine';
import {
    RepairOrderRequestLineFromJSON,
    RepairOrderRequestLineFromJSONTyped,
    RepairOrderRequestLineToJSON,
} from './RepairOrderRequestLine';

/**
 * 
 * @export
 * @interface RepairOrderRequest
 */
export interface RepairOrderRequest {
    /**
     * 
     * @type {string}
     * @memberof RepairOrderRequest
     */
    serviceRequestTypeId: string | null;
    /**
     * 
     * @type {string}
     * @memberof RepairOrderRequest
     */
    customerId: string | null;
    /**
     * 
     * @type {string}
     * @memberof RepairOrderRequest
     */
    roId: string | null;
    /**
     * 
     * @type {string}
     * @memberof RepairOrderRequest
     */
    roNumber: string | null;
    /**
     * 
     * @type {Array<RepairOrderRequestLine>}
     * @memberof RepairOrderRequest
     */
    lines?: Array<RepairOrderRequestLine> | null;
    /**
     * 
     * @type {string}
     * @memberof RepairOrderRequest
     */
    notes: string | null;
    /**
     * 
     * @type {string}
     * @memberof RepairOrderRequest
     */
    vin: string | null;
    /**
     * 
     * @type {string}
     * @memberof RepairOrderRequest
     */
    vehicleYear: string | null;
    /**
     * 
     * @type {string}
     * @memberof RepairOrderRequest
     */
    vehicleMake: string | null;
    /**
     * 
     * @type {string}
     * @memberof RepairOrderRequest
     */
    vehicleModel: string | null;
    /**
     * 
     * @type {Date}
     * @memberof RepairOrderRequest
     */
    requestedDate: Date | null;
    /**
     * 
     * @type {string}
     * @memberof RepairOrderRequest
     */
    licensePlateNum?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RepairOrderRequest
     */
    licensePlateState?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RepairOrderRequest
     */
    interiorColor?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RepairOrderRequest
     */
    exteriorColor?: string | null;
    /**
     * 
     * @type {number}
     * @memberof RepairOrderRequest
     */
    odometer?: number | null;
    /**
     * 
     * @type {string}
     * @memberof RepairOrderRequest
     */
    condition?: string | null;
    /**
     * 
     * @type {number}
     * @memberof RepairOrderRequest
     */
    bodyRate?: number | null;
    /**
     * 
     * @type {number}
     * @memberof RepairOrderRequest
     */
    mechanicalRate?: number | null;
    /**
     * 
     * @type {string}
     * @memberof RepairOrderRequest
     */
    estimator?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RepairOrderRequest
     */
    insuranceCompany?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RepairOrderRequest
     */
    claimNumber?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof RepairOrderRequest
     */
    lossDate?: Date | null;
}

/**
 * Check if a given object implements the RepairOrderRequest interface.
 */
export function instanceOfRepairOrderRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "serviceRequestTypeId" in value;
    isInstance = isInstance && "customerId" in value;
    isInstance = isInstance && "roId" in value;
    isInstance = isInstance && "roNumber" in value;
    isInstance = isInstance && "notes" in value;
    isInstance = isInstance && "vin" in value;
    isInstance = isInstance && "vehicleYear" in value;
    isInstance = isInstance && "vehicleMake" in value;
    isInstance = isInstance && "vehicleModel" in value;
    isInstance = isInstance && "requestedDate" in value;

    return isInstance;
}

export function RepairOrderRequestFromJSON(json: any): RepairOrderRequest {
    return RepairOrderRequestFromJSONTyped(json, false);
}

export function RepairOrderRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RepairOrderRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'serviceRequestTypeId': json['serviceRequestTypeId'],
        'customerId': json['customerId'],
        'roId': json['roId'],
        'roNumber': json['roNumber'],
        'lines': !exists(json, 'lines') ? undefined : (json['lines'] === null ? null : (json['lines'] as Array<any>).map(RepairOrderRequestLineFromJSON)),
        'notes': json['notes'],
        'vin': json['vin'],
        'vehicleYear': json['vehicleYear'],
        'vehicleMake': json['vehicleMake'],
        'vehicleModel': json['vehicleModel'],
        'requestedDate': (json['requestedDate'] === null ? null : new Date(json['requestedDate'])),
        'licensePlateNum': !exists(json, 'licensePlateNum') ? undefined : json['licensePlateNum'],
        'licensePlateState': !exists(json, 'licensePlateState') ? undefined : json['licensePlateState'],
        'interiorColor': !exists(json, 'interiorColor') ? undefined : json['interiorColor'],
        'exteriorColor': !exists(json, 'exteriorColor') ? undefined : json['exteriorColor'],
        'odometer': !exists(json, 'odometer') ? undefined : json['odometer'],
        'condition': !exists(json, 'condition') ? undefined : json['condition'],
        'bodyRate': !exists(json, 'bodyRate') ? undefined : json['bodyRate'],
        'mechanicalRate': !exists(json, 'mechanicalRate') ? undefined : json['mechanicalRate'],
        'estimator': !exists(json, 'estimator') ? undefined : json['estimator'],
        'insuranceCompany': !exists(json, 'insuranceCompany') ? undefined : json['insuranceCompany'],
        'claimNumber': !exists(json, 'claimNumber') ? undefined : json['claimNumber'],
        'lossDate': !exists(json, 'lossDate') ? undefined : (json['lossDate'] === null ? null : new Date(json['lossDate'])),
    };
}

export function RepairOrderRequestToJSON(value?: RepairOrderRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'serviceRequestTypeId': value.serviceRequestTypeId,
        'customerId': value.customerId,
        'roId': value.roId,
        'roNumber': value.roNumber,
        'lines': value.lines === undefined ? undefined : (value.lines === null ? null : (value.lines as Array<any>).map(RepairOrderRequestLineToJSON)),
        'notes': value.notes,
        'vin': value.vin,
        'vehicleYear': value.vehicleYear,
        'vehicleMake': value.vehicleMake,
        'vehicleModel': value.vehicleModel,
        'requestedDate': (value.requestedDate === null ? null : value.requestedDate.toISOString()),
        'licensePlateNum': value.licensePlateNum,
        'licensePlateState': value.licensePlateState,
        'interiorColor': value.interiorColor,
        'exteriorColor': value.exteriorColor,
        'odometer': value.odometer,
        'condition': value.condition,
        'bodyRate': value.bodyRate,
        'mechanicalRate': value.mechanicalRate,
        'estimator': value.estimator,
        'insuranceCompany': value.insuranceCompany,
        'claimNumber': value.claimNumber,
        'lossDate': value.lossDate === undefined ? undefined : (value.lossDate === null ? null : value.lossDate.toISOString()),
    };
}

